import type { ApiRoute, NoBody, NoPathParams } from "../api"
import type { ChangeWheelsView } from "./wheels/ChangeWheelsView"
import type { GetWheelsQueryParams } from "./wheels/GetWheelsQueryParams"

export const getWheelsRoute: ApiRoute<NoPathParams, GetWheelsQueryParams, NoBody, ChangeWheelsView> = {
	buildUrl: () => "/equipment/wheels",
	method: "get",
	path: "/equipment/wheels",
}
